import { watch } from 'vue'
import { dateService, FORMATS } from '@/global/services/date'

const MIDNIGHT = '00:00'
const END_OF_DAY = '23:59'

// An end picked on the same day as the start comes in at 00:00, because the
// picker fills the time it was not given - and 00:00 on the start's own day is
// before the start, so the range reads as empty. A one-day job is what the user
// meant, so the end becomes 23:59.
//
// Only when the time is still 00:00: a time the user typed is left alone, which
// is what "unless specified otherwise" means here.
export function useSameDayEndOfDay (target, startKey, endKey, fmt = FORMATS.datetimeShort) {
  watch(
    () => [target?.[startKey], target?.[endKey]],
    ([start, end], previous) => {
      // The form's first fill arrives as one change with nothing before it.
      // Rewriting a stored value on open would edit the order behind the user's
      // back, so only picks made afterwards count.
      const [previousStart, previousEnd] = previous || []
      if (previousStart === undefined && previousEnd === undefined) {
        return
      }

      if (!target || !start || !end) {
        return
      }

      // `parse`, not `formatCustom`: the latter converts into the configured
      // timezone, which can move a value onto the neighbouring day and make the
      // two reads disagree about what "same day" is. The guard beside this one
      // compares without converting for the same reason.
      const startDay = dateService.parse(start, fmt, FORMATS.date)
      const endDay = dateService.parse(end, fmt, FORMATS.date)

      if (!startDay || !endDay || startDay !== endDay) {
        return
      }

      if (dateService.parse(end, fmt, FORMATS.timeShort) !== MIDNIGHT) {
        return
      }

      target[endKey] = `${endDay} ${END_OF_DAY}`
    }
  )
}
